import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../AuthContext";

// L'adresse n'est jamais embarquée dans le bundle : elle vient d'une route /api
// protégée par l'authentification.
const PostalAddress = () => {
  const { getToken, loading } = useContext(AuthContext);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    const loadAddress = async () => {
      if (loading) return;
      try {
        const token = await getToken();
        const res = await fetch("/api/address", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        setAddress(data.postal_address || null);
      } catch (error) {
        console.error("Erreur lors du chargement de l'adresse :", error);
        setAddress(null);
      }
    };
    loadAddress();
  }, [getToken, loading]);

  if (!address) return null;

  return (
    <div style={{
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '16px',
      marginTop: '30px',
      textAlign: 'left'
    }}>
      <h3 style={{ marginTop: 0 }}>📮 Notre adresse postale</h3>
      <p>
        Si vous préférez nous envoyer un cadeau, une carte ou un petit mot,
        vous pouvez nous écrire à :
      </p>
      <p><strong>{address}</strong></p>
      <p style={{ marginBottom: 0, fontSize: '0.9em' }}>
        Merci de garder cette adresse pour vous : elle n'est visible que par les
        personnes connectées au site.
      </p>
    </div>
  );
};

export default PostalAddress;
